// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"3105d3c4","110":"0d8f478c","423":"35dbc7ac","453":"89bceea4","483":"7c87d589","548":"075912c6","639":"17b20106","746":"7b9f57cb","854":"429cadce","981":"e1f0db93"}[chunkId] + ".chunk.js";
};